import { render, staticRenderFns } from "./ListaCadastroTeste.vue?vue&type=template&id=725c295e&"
import script from "./ListaCadastroTeste.vue?vue&type=script&lang=js&"
export * from "./ListaCadastroTeste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports